export const validation = {
  description: "Description is required",
};
